
import React from "react";

// reactstrap components
import { Container } from "reactstrap";

class Header extends React.Component {
  render() {
    return (
      <>
        <div className="header   pt-5 pt-md-4">
          <Container fluid>
            <div className="header-body">
             
            </div>
          </Container>
        </div>
      </>
    );
  }
}

export default Header;
